export default function isFileSizeValid({ file, maxSize = 10 }) {
  if (!file) return true

  const MAX_SIZE_IN_BYTES = maxSize * 1000000

  return file.size <= MAX_SIZE_IN_BYTES
}
